import { HOME_LAYOUT_HEIGHT } from "../../../app/common";

// TODO: add Interviews height when implemented
const SPACING_HEIGHT = "172px";
export const LIST_HEIGHT = `calc(${HOME_LAYOUT_HEIGHT} - ${SPACING_HEIGHT})`;
